export default __webpack_public_path__ + "static/media/tinkercad-create.3ca520cf.png";